module.exports = __webpack_public_path__ + "fonts/RenaultLife-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Regular.eot
// module id = 343
// module chunks = 0